//SelectEventStateDialog
//***********************************************************************************************************************
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { IIdCode, IdCode } from "../../models/common/idCode";
import { Dialog } from "../framework/dialog";
import { DialogButtonType } from "ui/Scripts/source/models/enums";

//EventStateLine
export interface IEventStateLineProp {
    classes?: string;
    item: IIdCode;
}

export class EventStateLine extends React.Component<IEventStateLineProp, {}> {
    render() {
        const props = this.props;
        const item = props.item;
        const eState = item.id === "6" ? 4 : (item.id === "5" ? 3 : (item.id === "4" ? 2 : (item.id === "3" ? 1 : 0)));
        const approved = item.id === "2";
        const notApproved = item.id === "1";
        return (
            <div className={"flex" + (props.classes ? " " + props.classes : "")}>
                {eState > 0 &&
                    <span className={"stateText event state" + item.id}>{item.code}</span>
                }
                {(approved || notApproved) &&
                    <span className={"icon approved " + (notApproved ? " red" : "")} title={notApproved ? Translations.EventIsNotApprovedByUser : Translations.EventIsApprovedByUser}></span>
                }
                {eState < 0.5 &&
                    <span className={approved || notApproved ? "pl-2" : ""}>{item.code}</span>
                }
            </div>
        );
    }
}

//SelectEventStateDialogLine
export interface ISelectEventStateDialogProp {
    item: IIdCode;
    selected: boolean;
    onClick: (id: string) => void;
}

export class SelectEventStateDialogLine extends React.Component<ISelectEventStateDialogProp, {}> {
    handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClick(this.props.item.id);
    };

    render() {
        const item = this.props.item;
        const eState = item.id === "6" ? 4 : (item.id === "5" ? 3 : (item.id === "4" ? 2 : (item.id === "3" ? 1 : 0)));
        return (
            <div className={"line" + (eState > 0 ? " es s" + item.id : "") + (this.props.selected ? " selected" : "")} onClick={this.handleClick}>
                <div className="row">
                    <div className={"col col-12"}>
                        <EventStateLine classes={"singleLine"} item={item} />
                    </div>
                </div>
            </div>
        );
    }
}

//SelectEventStateDialog
export interface ISelectEventStateDialogProps {
    classes?: string;
    title: string;
    selectedId: string;
    loadIdCodes: (page: number) => Promise<IEndlessList<IdCode>>;
    onOk: (id: string, code: string) => void;
    onCancel: () => void;
}

export interface ISelectEventStateDialogState {
    idCodes: IIdCode[];
    page: number;
    hasMore: boolean;
    isLoading: boolean;
    selectedId: string;
}

export class SelectEventStateDialog extends React.Component<ISelectEventStateDialogProps, ISelectEventStateDialogState> {
    private containerDiv: HTMLDivElement;
    private listDiv: HTMLDivElement;

    constructor(props) {
        super(props);
        this.state = { idCodes: [], selectedId: props.selectedId, page: 1, isLoading: false, hasMore: true };
    }

    loadIdCodes = (page: number) => {
        const obj = this;
        this.props.loadIdCodes(page).then(userList => {
            if (Base.isNullOrUndefined(userList)) return;
            const oldIds = {};
            for (let j = 0; j < obj.state.idCodes.length; j++) {
                oldIds[obj.state.idCodes[j].id] = true;
            }
            const newItems = userList.items.filter(i => Object.prototype.hasOwnProperty.call(oldIds, i.id) ? false : (oldIds[i.id] = true));
            obj.setState({ idCodes: [...obj.state.idCodes, ...newItems], page: userList.page, hasMore: userList.hasMore });
        });
    };
        
    handleScrollSub = Base.debounce((obj) => {
        if (obj.state.isLoading || !obj.state.hasMore) return;
        if (obj.containerDiv.clientHeight + obj.containerDiv.scrollTop === obj.listDiv.offsetHeight) {
            obj.loadIdCodes(obj.state.page + 1);
        }
    }, 100);

    handleScroll = (event) => {
        this.handleScrollSub(this);
    };

    handleLineClick = (id: string) => {
        if (Base.isNullOrEmpty(id)) return;
        const idCode = this.state.idCodes.find(i => i.id === id);
        if (Base.isNullOrUndefined(idCode)) return;
        this.setState({
            selectedId: id
        });
        this.props.onOk(idCode.id, idCode.code);
    };

    componentDidMount(): void {
        this.containerDiv.addEventListener("scroll", this.handleScroll);
        this.loadIdCodes(1);
    }

    componentWillUnmount(): void {
        this.containerDiv.removeEventListener("scroll", this.handleScroll);
    }

    handleCancelClick = () => {
        this.props.onCancel();
    };

    render() {
        const dialogClasses = "selectEventStateDialog" + (!Base.isNullOrEmpty(this.props.classes) ? " " + this.props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={this.props.title}
                body={
                    <div className="largeDialogContent" ref={(elem) => { this.containerDiv = elem; }}>
                        <div className="lineContainer" ref={(elem) => { this.listDiv = elem; }}>
                            {this.state.idCodes.map(item => (
                                <SelectEventStateDialogLine
                                    key={item.id}
                                    item={item}
                                    selected={this.state.selectedId === item.id}
                                    onClick={this.handleLineClick}
                                />
                            ))}
                        </div>
                    </div>
                }
                buttons={[{ title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancelClick }]}
                onClose={this.handleCancelClick}/>
        );
    }
}